import type { Landmark } from '../../../data/types';
import type { Ring } from '../../../geo/types';
import { createMeshBuilder } from '../../mesh/meshBuilder';
import { meshBarriers, type Levels } from '../../mesh/planBarriers';
import { buildDam, type DamColors } from './dam';

/* Only the dam's shape is read here, and no colour changes it. */
const UNPAINTED: DamColors = {
  wall: [0, 0, 0],
  pavement: [0, 0, 0],
  gate: [0, 0, 0],
  house: [0, 0, 0],
  slate: [0, 0, 0],
  roof: [0, 0, 0],
  opening: [0, 0, 0],
  trim: [0, 0, 0],
};

/** The plan of every part of the dams that stands between two levels, for each pair of levels
 *  asked, read off the dam's own mesh: its abutments and the low haunches of its vault stop a
 *  boat, and the passage under the crown lets it through. */
export function damBarriers(
  landmarks: readonly Landmark[],
  bands: readonly Levels[]
): readonly (readonly Ring[])[] {
  const perDam = landmarks
    .filter((landmark) => landmark.kind === 'dam')
    .map((landmark) => {
      const builder = createMeshBuilder();
      buildDam(builder, landmark, UNPAINTED, { edgeId: 0, seed: 0 }, () => undefined);
      const geometry = builder.finish();
      const barriers = meshBarriers(geometry, bands);
      geometry.dispose();
      return barriers;
    });
  return bands.map((_, band) => perDam.flatMap((rings) => rings[band]!));
}
